// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getSignupAPI } from "../../services/Api/UserApi"
import { getErrors, getUserPhone, getUserSuccess } from "../reducers/userInfoReducer"
import {toast, ToastContainer } from "react-toastify"
// Watchers
function* userInfoSaga() {
	yield takeEvery("users/getUsers", getUser)
}

// Sagas
function* getUser(action) {
	// console.log(action, "saga payload")
	yield put(getUserPhone(action.payload))
	try {
		const userData = yield call(getSignupAPI, action.payload)
		// console.log(userData, "saga response")
		if (userData.status == 200) {
			yield put(getUserSuccess(userData))
			// yield put(getOtpMessageSuccess(userData))
			
		} else {
			yield put(getErrors(userData.response.data))

			/* user signup error message */
			
			// if(userData.response.data.password1){
			// 	toast.error(`${userData.response.data.password1}`, {
			// 		position: "top-right",
			// 		autoClose: 2000,
			// 		hideProgressBar: false,
			// 		closeOnClick: true,
			// 		pauseOnHover: true,
			// 		draggable: true,
			// 		progress: undefined,
			// 	})
			// }
			
			// else if(userData.response.data.full_name){
			// 	toast.error(`${userData.response.data.full_name}`, {
			// 		position: "top-right",
			// 		autoClose: 2000,
			// 		hideProgressBar: false,
			// 		closeOnClick: true,
			// 		pauseOnHover: true,
			// 		draggable: true,
			// 		progress: undefined,
			// 	})
			// }
			// else if(userData.response.data.non_field_errors[0]){
			// 	toast.error(`${userData.response.data.non_field_errors[0]}`, {
			// 		position: "top-right",
			// 		autoClose: 2000,
			// 		hideProgressBar: false,
			// 		closeOnClick: true,
			// 		pauseOnHover: true,
			// 		draggable: true,
			// 		progress: undefined,
			// 	})
			// }
			 
			
			 
		}
	} catch (error) {
		yield put(getErrors(error))

	}
}

export default function* rootSaga() {
	yield all([fork(userInfoSaga)])
}
